import { render, staticRenderFns } from "./VoucherLicenseCard.vue?vue&type=template&id=0b847845&scoped=true&"
import script from "./VoucherLicenseCard.vue?vue&type=script&lang=ts&"
export * from "./VoucherLicenseCard.vue?vue&type=script&lang=ts&"
import style0 from "./VoucherLicenseCard.vue?vue&type=style&index=0&id=0b847845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b847845",
  null
  
)

export default component.exports